import getCookie from './get-cookie';

const mainFunction = () => {
    const deliverySelectionPopup = document.querySelector('#delivery-selection-popup');

    if (!deliverySelectionPopup) return;

    const pickupMenuTypeInput = document.querySelector('.pickup-menu-type');
    const editAddressButton = document.querySelector('.choose-address');
    const editRestaurantsButtons = document.querySelectorAll('.choose-restaurant');
    const restaurantRadioInputs = document.querySelectorAll('.restaurant-radio');
    const deliveryControls = document.querySelector('.delivery-controls-wrapper');
    const addressFormWrapper = document.querySelector('.address-form-wrapper');
    const restaurantsForm = document.querySelector('.restaurant-form');
    const addressForm = document.querySelector('.order-address-form');
    const popupDeliverySelectionButtons = document.querySelectorAll('.cart-type[name="popup-delivery-type"]');
    const deliverySelectionButtons = document.querySelectorAll('.cart-type[name="delivery-type"]');
    const checkedDeliverySelectionButton = document.querySelector('.cart-type[name="delivery-type"][checked]');
    const changeTypeSubmitButton = document.querySelector('.change-type-submit');
    const inputMainType = deliverySelectionPopup.querySelector('.main-type');
    const cartId = getCookie('cartId');

    let formValues = {};
    const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;
    if (formValuesFromSessionStorage) {
        formValues = JSON.parse(formValuesFromSessionStorage);
    }

    const {
        deliveryOrganizationId,
        organizationId,
    } = formValues;

    [].forEach.call(popupDeliverySelectionButtons, (button) => {
        button.addEventListener('change', () => {
            button.checked = true;

            if (inputMainType) {
                inputMainType.value = button.dataset.type;

                formValues.menuType = button.dataset.type;
                if (sessionStorage) {
                    sessionStorage.setItem('formValues', JSON.stringify(formValues));
                }

                if (pickupMenuTypeInput) {
                    pickupMenuTypeInput.value = button.dataset.type;
                }
            }

            if (changeTypeSubmitButton) {
                const isActiveButton = button.dataset.type === 'delivery' ? !!deliveryOrganizationId : !!organizationId;

                changeTypeSubmitButton.classList[isActiveButton ? 'remove' : 'add']('disabled');
            }
        });
    });

    if (checkedDeliverySelectionButton
        && (!cartId
            || (checkedDeliverySelectionButton.dataset.type === 'delivery' && !deliveryOrganizationId)
            || (checkedDeliverySelectionButton.dataset.type !== 'delivery' && !organizationId))) {
        deliverySelectionPopup.classList.add('active');
    }

    const toggleSubmenu = (form, show) => {
        deliveryControls && deliveryControls.classList[show ? 'add' : 'remove']('hidden');
        form && form.classList[show ? 'remove' : 'add']('hidden');
        hideInAccessibleRestaurants(formValues.menuType);
    }

    const hideInAccessibleRestaurants = (menuType) => {
        [].forEach.call(restaurantRadioInputs, (input) => {
            if (menuType === 'cafe' && input.dataset.virtualqueue === 'false') {
                input.parentElement.classList['add']('hidden');
            } else {
                input.parentElement.classList['remove']('hidden');
            }
        });
    }

    if (editAddressButton) {
        editAddressButton.addEventListener('click', () => {
            toggleSubmenu(addressFormWrapper, true);
        });
    }

    [].forEach.call(editRestaurantsButtons, (button) => {
        button.addEventListener('click', () => {
            toggleSubmenu(restaurantsForm, true);
        });
    });

    if (restaurantsForm) {
        restaurantsForm.addEventListener('submit', () => {
            const inputStatusPage = restaurantsForm.querySelector('.status-page');
            inputStatusPage.value = 'submitForm';
        });

        const restaurantsFormButtonBack = restaurantsForm.querySelector('.back-btn');

        if (restaurantsFormButtonBack && restaurantsForm) {
            restaurantsFormButtonBack.addEventListener('click', (e) => {
                e.preventDefault();

                toggleSubmenu(restaurantsForm, false);
            });
        }
    }

    if (addressForm) {
        addressForm.addEventListener('submit', () => {
            const inputStatusPage = addressForm.querySelector('.status-page');
            inputStatusPage.value = 'submitForm';
        });

        const addressFormButtonBack = addressForm.querySelector('.back-btn');

        if (addressFormButtonBack && addressFormWrapper) {
            addressFormButtonBack.addEventListener('click', (e) => {
                e.preventDefault();

                toggleSubmenu(addressFormWrapper, false);
            });
        }
    }

    if (changeTypeSubmitButton) {
        changeTypeSubmitButton.addEventListener('click', () => {
            const inputMainType = deliverySelectionPopup.querySelector('.main-type');

            if (inputMainType.value === 'delivery' && addressForm) {
                const inputStatusPage = addressForm.querySelector('.status-page');
                inputStatusPage.value = 'submitForm';
                addressForm.submit();
                return;
            }

            if (inputMainType.value !== 'delivery-togo' && restaurantsForm) {
                const inputStatusPage = restaurantsForm.querySelector('.status-page');
                inputStatusPage.value = 'submitForm';
                restaurantsForm.submit();
            }
        });
    }

    [].forEach.call(deliverySelectionButtons, (button) => {
        button.removeAttribute('disabled');
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const popupDeliverySelectionButton = document.querySelector(
                '.cart-type[name="popup-delivery-type"][data-type="'+button.dataset.type+'"]'
            );

            if (popupDeliverySelectionButton) {
                popupDeliverySelectionButton.checked = true;
            }

            if (inputMainType) {
                inputMainType.value = button.dataset.type;

                formValues.menuType = button.dataset.type;
                if (sessionStorage) {
                    sessionStorage.setItem('formValues', JSON.stringify(formValues));
                }

                if (pickupMenuTypeInput) {
                    pickupMenuTypeInput.value = button.dataset.type;
                }
            }

            if (deliveryControls) {
                deliveryControls.classList.remove('hidden');
            }

            if (addressFormWrapper) {
                !addressFormWrapper.classList.contains('hidden') && addressFormWrapper.classList.add('hidden');
            }

            if (restaurantsForm) {
                !restaurantsForm.classList.contains('hidden') && restaurantsForm.classList.add('hidden');
            }

            deliverySelectionPopup.classList.add('active');

            if (changeTypeSubmitButton) {
                const isActiveButton = button.dataset.type === 'delivery' ? !!deliveryOrganizationId : !!organizationId;

                changeTypeSubmitButton.classList[isActiveButton ? 'remove' : 'add']('disabled');
            }
        });
    });
};

window.addEventListener('load', mainFunction);

window.addEventListener('beforeunload', () => window.removeEventListener('load', mainFunction));
